<template>
  <div class="footer_social">
    <a
      :href="val.path"
      v-for="(val, i) in socials"
      :key="`soccl-${ i }`"
      :style="{ 'background-color': val.color }"
      target="_blank"
      class="footer_social_item"
      rel="nofollow"
    >
      <img v-if="val.icon === 'telegram'" src="/icons/telegram.png" alt="">
      <font-awesome-icon :icon="['fab', val.icon]" v-else />
    </a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    socials () {
      return this.$region.getSocials()
    },
  },
}
</script>

<style lang="less">
.footer_social {
  display: flex;
  justify-content: center;
  align-self: center;

  &_item {
    width: 25px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    font-size: 16px;
    color: white;
    overflow: hidden;

    &:not(:last-child) {
      margin-right: 12px;
    }

    img {
      height: 25px;
    }
  }
}
</style>
